module.exports = __webpack_public_path__ + "img/tab_01.9577bd1d.png";